import api from './api.mjs'

const getSearchResults = async ({
  text,
  setResults
}) => {
  const results = await api(text,'get-search-results')

  setResults(results)
}

export default getSearchResults